import React, { FC } from "react";

import "./AreasTree.scss";
import { BareFeedArea, FeedArea } from "@go-shared/types/feedTemplate";

interface AreasTreeProps {
  areas: BareFeedArea[];
  currentArea: BareFeedArea | FeedArea | null;
  onBranchClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, indices: number[]) => void;
  hoveredArea: BareFeedArea | FeedArea | null;
  setHoveredArea: (area: BareFeedArea | FeedArea | null) => void;
}

export const AreasTree: FC<AreasTreeProps> = ({
  areas,
  currentArea,
  onBranchClick,
  hoveredArea,
  setHoveredArea,
}) => {
  function getBranches(areas: BareFeedArea[]): React.JSX.Element[] {
    return areas.map((area, index) => {
      let childBranches;

      if (area.children?.length) {
        childBranches = getChildBranches(area.children, [index]);
      }

      const activeClass = area === currentArea ? 'active' : '';
      const lockedIcon = area.isLocked ? ' 🔒' : '';
      const isHovered = area === hoveredArea;
      const hoverStyles = isHovered
        ? {
            fontWeight: 'bold',
          }
        : {};

      return (
        <div key={area._id}>
          <div
            className={`branch ${activeClass}`}
            onClick={e => onBranchClick(e, [index])}
            onMouseOver={() => setHoveredArea(area)}
            onMouseLeave={() => setHoveredArea(null)}
            style={hoverStyles}
          >
            {`⦿ ${area.name}${lockedIcon}`}
          </div>
          {childBranches}
        </div>
      );
    });
  }

  function getChildBranches(areas: FeedArea[], indices: number[]): React.JSX.Element[] {
    return areas.map((area, index) => {
      let childBranches;

      if (area.children?.length) {
        childBranches = getChildBranches(area.children, [...indices, index]);
      }

      const activeClass = area === currentArea ? 'active' : '';
      const spaces = indices.length ? indices.length - 1 : 0;
      const lockedIcon = area.isLocked ? ' 🔒' : '';
      const isHovered = area === hoveredArea;
      const hoverStyles = isHovered
        ? {
            fontWeight: 'bold',
          }
        : {};

      return (
        <div key={area._id}>
          <div
            key={area._id}
            className={`branch ${activeClass}`}
            onClick={e => onBranchClick(e, [...indices, index])}
            onMouseOver={() => setHoveredArea(area)}
            onMouseLeave={() => setHoveredArea(null)}
            style={hoverStyles}
          >
            <pre>{`${'   '.repeat(spaces)}┗━━ ${area.name}${lockedIcon}`}</pre>
          </div>
          {childBranches}
        </div>
      );
    });
  }

  return <section className="areas-tree">{getBranches(areas)}</section>;
};
